import { CustomerDocument, LawyerDocument } from '@app/graphql/types'

export const useDocumentMetadata = (document: CustomerDocument | LawyerDocument) => {
  const isChecked = document.__typename === 'CustomerDocument' && document.checked === true
  const fileUrl = document.fileUrl
  const fileFormat = document.fileFormat ?? 'UNKNOWN'
  const date = new Date(document.createdAt)

  return { isChecked, fileUrl, fileFormat, date }
}
